import { useGetNotificationV2 } from "api/investor/queries";
import { logoutAndRedirect } from "api/user";
import { Amplify } from "aws-amplify";
import Input from "components/InvestorCommon/InputV2/Input";
import Notification from "components/InvestorCommon/Notification/Notification";
import { useAppDispatch, useAppSelector } from "hooks/reduxHook";
import Cookies from "js-cookie";
import moment from "moment";
import { routesEnum } from "pages/Routes";
import { FC, useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import { getUser } from "store/ducks/investor/slice";
import { setType } from "store/ducks/system/slice";
import { IMAGES } from "utils/images";
import * as appSync from "../../api/notification/appsync.js";
import { HeaderWrapper } from "./styled";

Amplify.configure(appSync.config);

const channel = {
	NOTIFICATION: "NOTIFICATION",
	ANNOUNCEMENT: "ANNOUNCEMENT",
	LOG_OUT: "LOG_OUT",
};

interface IRightHeader {
	showAnnouncement: boolean;
	setShowAnnouncement: any;
}
interface IHeader {
	showAnnouncement: boolean;
	setShowAnnouncement: any;
}

const Left: FC = () => {
	return (
		<div className="flex h-full items-center">
			<Link to={routesEnum.home}>
				<img
					alt=""
					src={IMAGES.logo.logo_red}
					width="200px"
					height="48px"
					style={{
						marginRight: "116px",
					}}
				/>
			</Link>
			<div style={{ width: "500px" }} className="hidden lg:block">
				<Input placeholder="Search" mode="search" />
			</div>
		</div>
	);
};

const Right: FC<IRightHeader> = (props: IRightHeader) => {
	const dataUser = useAppSelector(getUser);
	const furthestDate = moment(new Date()).subtract(2, "month").toISOString();
	const { data, refetch } = useGetNotificationV2(furthestDate, dataUser?.id || "", {
		enabled: !!dataUser?.id,
	});
	const { showAnnouncement, setShowAnnouncement } = props;
	const [showNotification, setShowNotification] = useState(false);
	const listNotification = data || [];
	const [totalNotification, setTotalNotification] = useState(0);
	const dispatch = useAppDispatch();
	const location = useLocation();

	const handleLogout = async () => {
		toast.success("Logout successfully!", {
			autoClose: 1000,
		});
		dispatch(setType(""));
		const currentRoute = `${location.pathname}${location.search}`;
		await logoutAndRedirect(currentRoute);
	};

	useEffect(() => {
		const subscription = appSync.subscribe(
			channel.NOTIFICATION,
			({ data }: any) => {
				data = JSON.parse(String(data));
				if (data.idArray?.includes(dataUser?.id)) {
					toast.success("You have a new notification!", {
						autoClose: 1000,
					});
					refetch();
				}
			},
			undefined,
		);

		const announcementSubscription = appSync.subscribe(
			channel.ANNOUNCEMENT,
			({ data }: any) => {
				data = JSON.parse(String(data));
				if (data.idArray?.includes(dataUser?.id)) {
					toast.success("You have a new announcement!", {
						autoClose: 1000,
					});
				}
			},
			undefined,
		);
		const userBeUnactive = appSync.subscribe(
			channel.LOG_OUT,
			({ data }: any) => {
				data = JSON.parse(String(data));
				if (data?.ids?.includes(dataUser?.id)) {
					handleLogout();
				}
			},
			undefined,
		);
		return () => {
			userBeUnactive.unsubscribe();
			subscription.unsubscribe();
			announcementSubscription.unsubscribe();
		};
	}, []);
	useEffect(() => {
		if (Array.isArray(data)) {
			const listTotalNotiUnread = data.filter((item) => item.noti_status);
			setTotalNotification(listTotalNotiUnread?.length);
		}
	}, [data]);
	return (
		<div className="flex h-full items-center">
			<div
				className="relative cursor-pointer"
				style={{
					marginRight: "23px",
				}}
				onClick={() => {
					setShowAnnouncement(!showAnnouncement);
					setShowNotification(false);
				}}
			>
				<img alt="" src={IMAGES.header.news} />
				<span className="-translate-y-1/2 absolute top-0 right-0 inline-block h-2 w-2 translate-x-1/2 transform rounded-full bg-orange-600"></span>
			</div>
			<div
				className="relative cursor-pointer"
				style={{
					marginRight: "23px",
				}}
			>
				<div
					onClick={() => {
						setShowNotification(!showNotification);
						setShowAnnouncement(false);
					}}
				>
					<img alt="" src={IMAGES.header.notification} />
					<span className="-translate-y-1/2 absolute top-0 right-0 inline-flex translate-x-1/2 transform items-center justify-center rounded-full bg-orange-600 px-2 py-1 font-bold text-orange-100 text-xs leading-none">
						{totalNotification}
					</span>
				</div>
				{showNotification && (
					<div className="absolute" style={{ right: "0px", top: "40px" }}>
						<Notification
							listNotification={listNotification}
							refetch={refetch}
							setShowNotification={() => setShowNotification(!showNotification)}
						/>
					</div>
				)}
			</div>
			<div className="cursor-pointer">
				<img
					alt=""
					src={IMAGES.header.avatar}
					className="rounded-full"
					style={{
						width: "43px",
						height: "43px",
					}}
				/>
			</div>
		</div>
	);
};

const Header: FC<IHeader> = (props: IHeader) => {
	const { showAnnouncement, setShowAnnouncement } = props;
	const dataUser = useAppSelector(getUser);
	return (
		<HeaderWrapper className="fixed top-0 hidden w-full flex-row items-center justify-between bg-white shadow md:flex">
			<Left />
			{dataUser && (
				<Right
					showAnnouncement={showAnnouncement}
					setShowAnnouncement={setShowAnnouncement}
				/>
			)}
		</HeaderWrapper>
	);
};

export default Header;
